<form [formGroup]="form" (submit)="submit()">
  <div class="modal-header">
    <div class="modal-header-title">Change Password</div>
  </div>

  <div class="modal-body">
    <div class="alert alert-info">
      <p class="text-center">Welcome to PowerReady!</p>
      <p class="text-center">Please, change your password.</p>
    </div>
    <div class="input-row">
      <ng6-agency-text
        inputLabel="Current Password"
        inputType="password"
        [formControl]="form.get(formKeys.CurrentPassword)"
      >
      </ng6-agency-text>
    </div>
    <div class="input-row">
      <ng6-agency-text inputLabel="Password" inputType="password" [formControl]="form.get(formKeys.Password)">
      </ng6-agency-text>
    </div>
    <div class="input-row">
      <ng6-agency-text
        inputLabel="Confirm Password"
        inputType="password"
        [formControl]="form.get(formKeys.ConfirmPassword)"
      >
      </ng6-agency-text>
    </div>
  </div>

  <div class="modal-footer">
    <div class="buttons-box">
      <spinner-button [pending]="pending" [disabled]="form | controlDisabled"> Save </spinner-button>
    </div>
  </div>
</form>
